import { argbFromHex, hexFromArgb, themeFromSourceColor} from '@material/material-color-utilities';

export default {
  getColorDesignJsonByHex (hexPrimaryColor, hexSecondaryColor) {
    const m3ThemeColorsPrimaryJSON = themeFromSourceColor(argbFromHex(hexPrimaryColor), []);
    const m3ThemeColorsSecondaryJSON = themeFromSourceColor(argbFromHex(hexSecondaryColor), []);
    const m3ThemeColorsJSONInHex = {
      schemes: {
        light: {
          primary: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.light.primary),
          onPrimary: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.light.onPrimary),
          primaryContainer: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.light.primaryContainer),
          onPrimaryContainer: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.light.onPrimaryContainer),
          secondary: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.light.primary),
          onSecondary: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.light.onPrimary),
          secondaryContainer: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.light.primaryContainer),
          onSecondaryContainer: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.light.onPrimaryContainer)
        },
        /*dark: {
          primary: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.dark.primary),
          onPrimary: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.dark.onPrimary),
          primaryContainer: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.dark.primaryContainer),
          onPrimaryContainer: hexFromArgb(m3ThemeColorsPrimaryJSON.schemes.dark.onPrimaryContainer),
          secondary: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.dark.secondary),
          onSecondary: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.dark.onSecondary),
          secondaryContainer: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.dark.secondaryContainer),
          onSecondaryContainer: hexFromArgb(m3ThemeColorsSecondaryJSON.schemes.dark.onSecondaryContainer)
        }*/
      }
    }
    return m3ThemeColorsJSONInHex
  }
}
